import React from 'react';
import Buttom from './Buttom';
import './list-styles.css';

const Multimedia = () =>
  <div className="listContainer">
    <ul>    
      <li key="1">2009-2015 - Digital Signage Video Templates        
        <Buttom title="Behance Project" src="https://www.behance.net/gallery/115260373/Digital-Menu-Board-Template-2014" />
        <Buttom title="Youtube Channel" src="https://www.youtube.com/channel/UCGcvBZErbM_umCupEeKjNiw/videos?view=0&sort=dd&shelf_id=0" />
      </li>
      <li key="2">2014 - Brand Identity and Website Design
        <Buttom title="Behance Project" src="https://www.behance.net/gallery/114950885/Web-Site-Design-Logo-Design-Brand-Identity" />
      </li>
      <li key="3">2014 - Brochure Design - MindTV
        <Buttom title="Behance Project" src="https://www.behance.net/gallery/114947335/Brochure-Design-2014" />
      </li>
      <li key="4">2014 - Video Opening for Mormaii YT Show
        <Buttom title="Youtube Video" src="https://www.youtube.com/watch?v=jDEAWJVyEMg" />
      </li>
      <li key="5">2008-2011 - Multimedia Creation
        <Buttom title="Behance Project" src="https://www.behance.net/gallery/115258455/2009-2011-Portfolio-Motion-Graphics" />
        <Buttom title="Youtube Channel" src="https://www.youtube.com/user/EcoarComunicacao/videos" />
      </li>
      <li key="6">2011 - Ecoar Brochure Design
        <Buttom title="Behance Project" src="https://www.behance.net/gallery/115258051/Brochure-Design-2011" />
      </li>
      <li key="7">2010 - ECOAR DVD Interactive Magazine
        <Buttom title="Youtube Video" src="https://www.youtube.com/watch?v=aqF7LaDdax8&list=PL8E0A21781DC42C56&index=1" />
      </li>
      <li key="8">2010 - Canarana.TV Video ad
        <Buttom title="Youtube Video" src="https://www.youtube.com/watch?v=5O04jMyEobw" />
      </li>
      <li key="9">2001 - Brochure Design HardMag Magazine
        <Buttom title="Youtube Video" src="https://www.behance.net/gallery/115290253/Print-Magazine-Design-55-pages-2001" />
      </li>
      <li key="10">2002 - Flash Intro for Global Source
        <Buttom title="Flash Animation" src="http://mleite.com.br/s/globalsource/flash/index.html" />
      </li>
      <li key="11">1996 - Flash Website for Studio Br
        <Buttom title="Flash Interactive" src="http://www.mleite.com.br/sbr99/flash/site/default.html" />
      </li>
    </ul>
  </div>

export default Multimedia
